/* unplugin-vue-components disabled */import { render } from "./InvalidNetwork.vue?vue&type=template&id=37f07c27"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__